import type { LessonPresentationFields } from "../auth/api-client";

export type TeacherPreviewContext = {
  lessonId: string;
  courseId?: string;
  cohortId?: string;
  lessonTitle?: string;
  /** SPA path to return to after preview (preserves creation context). */
  returnTo?: string;
  /** Lesson appearance, lets the preview theme its background instantly (before the API loads). */
  iconName?: string | null;
  iconBgColor?: string | null;
  iconFgColor?: string | null;
  workspaceMode?: string | null;
  /** When true, preview loads from the community catalog (read-only + copy action). */
  communitySource?: boolean;
};

/** Icon and accent fields for instant preview theming (URL query params). */
export function lessonPreviewAppearanceQuery(
  appearance: LessonPresentationFields
): Pick<TeacherPreviewContext, "iconName" | "iconBgColor" | "iconFgColor" | "workspaceMode"> {
  const q: Pick<TeacherPreviewContext, "iconName" | "iconBgColor" | "iconFgColor" | "workspaceMode"> =
    {};
  const iconName = appearance.iconName?.trim();
  const iconBgColor = appearance.iconBgColor?.trim();
  const iconFgColor = appearance.iconFgColor?.trim();
  if (iconName) q.iconName = iconName;
  if (iconBgColor) q.iconBgColor = iconBgColor;
  if (iconFgColor) q.iconFgColor = iconFgColor;
  if (appearance.workspaceMode) q.workspaceMode = appearance.workspaceMode;
  return q;
}

export function teacherPreviewLessonUrl(ctx: TeacherPreviewContext): string {
  const qs = new URLSearchParams({ lessonId: ctx.lessonId });
  if (ctx.courseId) qs.set("courseId", ctx.courseId);
  if (ctx.cohortId) qs.set("cohortId", ctx.cohortId);
  if (ctx.lessonTitle) qs.set("title", ctx.lessonTitle);
  if (ctx.returnTo) qs.set("returnTo", ctx.returnTo);
  if (ctx.iconName) qs.set("iconName", ctx.iconName);
  if (ctx.iconBgColor) qs.set("iconBgColor", ctx.iconBgColor);
  if (ctx.iconFgColor) qs.set("iconFgColor", ctx.iconFgColor);
  if (ctx.workspaceMode) qs.set("workspaceMode", ctx.workspaceMode);
  if (ctx.communitySource) qs.set("community", "1");
  return `/lesson-preview?${qs.toString()}`;
}

export function teacherPreviewBackLink(ctx: TeacherPreviewContext): { to: string; label: string } {
  if (ctx.cohortId) {
    return { to: `/teacher/cohorts/${encodeURIComponent(ctx.cohortId)}`, label: "Back" };
  }
  if (ctx.courseId) {
    return {
      to: `/teacher/courses/${encodeURIComponent(ctx.courseId)}`,
      label: "Back",
    };
  }
  return { to: `/teacher/lessons`, label: "Back" };
}
